// extracted by mini-css-extract-plugin
export default {"info":"TokenCard_info__7JePz","infoTitle":"TokenCard_infoTitle__5vyTk"};